module.exports = "/packs/images/svg/arrow_apple~0d3cc10d8ed4a05cf3ad32f8b6800c28.svg";